import axios from "../config/axios"

const BASE = (contractId) => `/on-contracts/${contractId}/payments`

export const onContractPaymentService = {
  // List all payments for a contract
  getAll: (contractId) => axios.get(BASE(contractId)),

  // Get single payment
  getOne: (contractId, paymentId) => axios.get(`${BASE(contractId)}/${paymentId}`),

  // Add a payment
  create: (contractId, data) => axios.post(BASE(contractId), data),

  // Update a payment
  update: (contractId, paymentId, data) => axios.put(`${BASE(contractId)}/${paymentId}`, data),

  // Delete a payment
  delete: (contractId, paymentId) => axios.delete(`${BASE(contractId)}/${paymentId}`),
}